import React, { useRef } from 'react';
import { useFileUpload } from '../hooks/useFileUpload';
import type { Bond } from '../types/bonds';

interface UploadButtonProps {
  onDataReceived?: (bonds: Bond[], fileName: string) => void;
}

export default function UploadButton({ onDataReceived }: UploadButtonProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { uploadFile, isUploading, uploadError, uploadSuccess, resetUploadState } = useFileUpload();

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      uploadFile(file, onDataReceived);
    }
    // Reset input value to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="upload-section">
      <input
        ref={fileInputRef}
        type="file"
        accept=".xls,.xlsx,.csv"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      <button
        className="upload-button"
        onClick={handleUploadClick}
        disabled={isUploading}
      >
        {isUploading ? (
          <>
            <span className="upload-spinner"></span>
            Ładowanie...
          </>
        ) : (
          <>
            📁 Wczytaj plik .xls
          </>
        )}
      </button>

      {/* Upload status messages */}
      {uploadError && (
        <div className="upload-error" onClick={resetUploadState}>
          <span>❌ {uploadError}</span>
          <button className="close-button">×</button>
        </div>
      )}
      {uploadSuccess && (
        <div className="upload-success" onClick={resetUploadState}>
          <span>✅ {uploadSuccess}</span>
          <button className="close-button">×</button>
        </div>
      )}
    </div>
  );
} 